import React, { useRef} from 'react';
import { observer } from 'mobx-react';
import { GISFooterVM } from './GISFooterVM';
import { FlatButton } from 'nrcs-design-system';
import { mdiPencilBoxOutline, mdiDownload } from '@mdi/js';
import './gisfooter.scss';
import { GISBoxVM } from '../GISBox/GISBoxVM';
import { ConfirmDialog } from '../../common/ConfirmDialog/ConfirmDialog';
import { ConfirmDialogVM } from '../../common/ConfirmDialog/ConfirmDialogVM';
import { UndoButton } from '../GISBox/UndoButton';
import { useHistory } from 'react-router-dom';
import Icon from '@mdi/react';
import { DownloadButton } from 'cd-eft/components/common/DownloadButton';
import stores from 'cd-eft/models/Stores';

interface IGISFooterComponentProps {
  vm: GISBoxVM;
  footerMessage: string;
  mapDrawMethods: any;
}

export const GISFooterComponent = (props: IGISFooterComponentProps) => {
  const dialogVM = useRef<ConfirmDialogVM>(new ConfirmDialogVM()).current;
  const history = useHistory();
  const vmRef = useRef<GISFooterVM>();
  if (!vmRef.current) {
    vmRef.current = new GISFooterVM(props, dialogVM, history);
  }
  const vm = vmRef.current;
  const gisBoxVm: GISBoxVM = props.vm;

  return (
    <footer>
      <div className="footer-container">
        <div className="col-md-12">
          {gisBoxVm.activityViewModel && gisBoxVm.activityViewModel.currentStepIndex === 0 ? (
            <div className="short-button-group">
              <WatershedActivitySubmitButton gisBoxVm={props.vm} dialogVM={dialogVM} vm={vm} />
            </div>
          ) : (
            <div
              className={
                gisBoxVm.activityViewModel &&
                  !(gisBoxVm.activityViewModel.currentStepIndex === 3 && !gisBoxVm.activityViewModel.landUseTableComplete)
                  ? 'row short-button-group'
                  : 'row short-button-group land-use-buttons'
              }
            >
              <div className="col-md-auto">
                <FlatButton iconLeft={mdiPencilBoxOutline} onClick={props.vm.openNotesModal}>
                  Add Comments
                </FlatButton>
                <DownloadButton
                  className="usa-button usa-button--outline download-button"
                  href=''
                  download={`NETS_Hydrology_GIS.zip`}
                  createLink={gisBoxVm.createGISFilesLinkWithNotification}
                  disabled={!(gisBoxVm.activityViewModel && !gisBoxVm.activityViewModel.jobExecuting)}
                  useTarget={true}
                >
                  <Icon path={mdiDownload} title="download" size={1} />
                  Download GIS
                </DownloadButton>
              </div>
              <div className="back-and-next-buttons">
                <div className="back-button">
                  {gisBoxVm.activityViewModel &&
                    !(
                      gisBoxVm.activityViewModel.currentStepIndex === 3 && gisBoxVm.activityViewModel.landUseTableComplete
                    ) ? (
                    <UndoButton activityViewModel={props.vm.activityViewModel!} textButton={true} />
                  ) : (
                    <button
                      className="usa-button"
                      disabled={!(gisBoxVm.activityViewModel && !gisBoxVm.activityViewModel.jobExecuting)}
                      hidden={
                        gisBoxVm.activityViewModel &&
                        !(
                          gisBoxVm.activityViewModel.currentStepIndex === 3 &&
                          gisBoxVm.activityViewModel.landUseTableComplete
                        )
                      }
                      onClick={() => {
                        vm.backFromSoilTable();
                      }}
                    >
                      Back
                    </button>
                  )}
                </div>
                <div className='' hidden={!(gisBoxVm.activityViewModel?.currentStepIndex === 2 && gisBoxVm.activityViewModel.velocityVm?.velocitySelected)}>
                  <button className='usa-button usa-button--outline' onClick={() => vm.resetAction()} disabled={gisBoxVm.activityViewModel?.velocityVm?.disableReset} >
                    Reset
                  </button>
                </div>
                <div className='' hidden={!(gisBoxVm.activityViewModel?.currentStepIndex === 2 && gisBoxVm.activityViewModel.velocityVm?.velocitySelected)}>
                  <button
                    className='usa-button usa-button--outline'
                    onClick={() => vm.calculateVelocityTable()}
                    // disabled={
                    //   !(
                    //     gisBoxVm.activityViewModel &&
                    //     !gisBoxVm.activityViewModel.jobExecuting &&
                    //     gisBoxVm.activityViewModel.velocityVm &&
                    //     gisBoxVm.activityViewModel.velocityVm.tableData &&
                    //     gisBoxVm.activityViewModel.velocityVm.tableData.some(row => row.flowType) &&
                    //     !gisBoxVm.activityViewModel.velocityVm.isSegmentsModified
                    //      && gisBoxVm.activityViewModel.velocityVm.minimumValidation()  //for now enabling it at all times
                    //   )
                    //    || !(gisBoxVm.activityViewModel.velocityVm.inputsChanged)
                    // }
                  >
                    Calculate
                  </button>
                </div>
                <div className="next-button">
                  {gisBoxVm.activityViewModel &&
                    !(
                      gisBoxVm.activityViewModel.currentStepIndex === 3 &&
                      !gisBoxVm.activityViewModel.landUseTableComplete
                    ) ? (
                    <WatershedActivitySubmitButton gisBoxVm={props.vm} dialogVM={dialogVM} vm={vm} />
                  ) : (
                    <div className="next-button">
                      <ConfirmDialog vm={dialogVM}></ConfirmDialog>
                      <button
                        disabled={
                          !(gisBoxVm.activityViewModel && !gisBoxVm.activityViewModel.jobExecuting) ||
                          gisBoxVm.activityViewModel.hydrologyValidationError
                        }
                        className="usa-button"
                        onClick={() => {
                          vm.nextFromLandTable();
                        }}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export const GISFooter = observer(GISFooterComponent);

interface IWatershedActivitySubmitButtonProps {
  gisBoxVm: GISBoxVM;
  dialogVM: ConfirmDialogVM;
  vm: GISFooterVM;
}
const WatershedActivitySubmitButton = observer((props: IWatershedActivitySubmitButtonProps) => {
  const { dialogVM, vm, gisBoxVm } = props;
  const efh2Store = stores.AppStore.efh2Store;

  if (!gisBoxVm.activityViewModel) {
    return null;
  }
  return (
    <div className="next-button">
      <ConfirmDialog vm={dialogVM}></ConfirmDialog>
      <button
        aria-label="Next"
        className="usa-button"
        disabled={
          !(gisBoxVm.activityViewModel && !gisBoxVm.activityViewModel.jobExecuting && !dialogVM.isOpen) ||
          gisBoxVm.activityViewModel.hydrologyValidationError || efh2Store.velocityInputUpdated
        }
        onClick={() => {
          vm.onSubmit();
        }}
      >
        Next
      </button>
      {/* Commenting out the downoad button until we have good UI for it */}
      {/* <button
        aria-label="Next"
        className="usa-button next-button"
        disabled={
          !(gisBoxVm.activityViewModel && !gisBoxVm.activityViewModel.jobExecuting && !dialogVM.isOpen) ||
          gisBoxVm.activityViewModel.hydrologyValidationError
        }
        onClick={() => {
          gisBoxVm.createGISFilesLink().then((value) => {

            if (value !== '') {
              const link = value
              const arr = link.split('/');
              const filename = arr[arr.length - 1]

              const ziplink = document.createElement('a');
              ziplink.href = link;
              ziplink.download = filename;
              ziplink.click();
            }

          });

        }}
      >
        Download
      </button> */}
    </div>
  );
});